import React from 'react';
import Icon from '../Icon/Icon';
import Loader from '../Loader/Loader';

function FileIcon({ loading, showError }) {
  if (loading) {
    return <Loader size="sm" />;
  }

  if (showError) {
    return <Icon name="error-filled" color="red600" size="sm" />;
  }

  return <Icon name="doc" color="gray400" size="sm" />;
}

export default FileIcon;
